import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageRuleAction } from '../coverageRule.action';
import { CoverageRuleTranslator } from '../coverageRule.translator';

type IDependencies = ICoverageApiDependencySegment;

export const updateCoverageRuleEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.rules.map(CoverageRuleTranslator.toApi);
    return coverageApi.updateCoverageRules(params.ruleSetId, { rules }).pipe(
      // The PUT response reports only problematic rules (errors/warnings) — surface them.
      mergeMap((response) => [CoverageRuleAction.update.done({
        params,
        result: (response.rules ?? []).map(CoverageRuleTranslator.fromApiValidation),
      })]),
      catchApiError((error) => {
        // Rules named by the 400 get row warnings; the failed save itself is still notified.
        const { result, restError, baseError } = CoverageRuleTranslator.fromApiRejection(error);
        return [
          CoverageRuleAction.update.failed({ params, error }),
          ...(result.length > 0 ? [CoverageRuleAction.validationRejected({ ruleSetId: params.ruleSetId, result })] : []),
          createApiErrorNotification(restError ?? baseError),
        ];
      }),
    );
  }),
);
